export default "__VITE_ASSET__D3Af4BpX__"